<div class="eventCard {{ EventColorMapping[event()?.eventColor] }}" role="region">
	<!--HEADER-->
	<section class="header" (click)="toggleEventOpen()">
		<div class="dateInfo">
			<span>{{ event().start | date: "EEE" :'': translate.currentLang }}</span>
			<span>{{ event().start | date: "dd" :'': translate.currentLang }}</span>
			<span>{{ event().start | date: "MMM, yyyy" :'': translate.currentLang }}</span>
		</div>
		<mat-divider vertical />
		<div class="eventInfo">
			<!--LABELS-->
			<div class="labelWrapper">
				<label class="primaryLabel">
					{{ event().name }}
				</label>
				<label class="secondaryLabel">
					<span class="sessionCount">
						{{ totalSessionCount() }}
					</span>
					{{ T.SHARED_EVENT_CONTAINER_SESSION_AMOUNT | translate }}
				</label>
			</div>

			<!--DESC-->
			@if (event().description?.length) {
				<p class="secondaryParagraph">
					{{ event().description }}
				</p>
			}

			<!--TAGS-->
			<div class="tagRow">
				<span class="dateTag">
					<mat-icon fontIcon="fa-calendar-day" fontSet="fas" />
					{{ event().start | date: "dd MMM yyyy" :'': translate.currentLang }}
					@if (!isSameDay(event().start, event().end)) {
						- {{ event().end | date: "dd MMM yyyy" :'': translate.currentLang }}
					}
				</span>

				@if (event().courseId && isArchive) {
					<sim-lms-publish-control [entityId]="event().id" />
				}

				<!--STATUS TAG-->
				<sim-event-status-tag [eventState]="event().state" />
			</div>
		</div>

		<!--ACTIONS-->
		<div class="actions">
			<button mat-icon-button class="expandButton" [class.rotate]="event().open">
				<mat-icon fontIcon="fa-chevron-down" fontSet="fad" color="accent" />
			</button>
			@if (eventActions?.selectEventBtn) {
				<button
					mat-icon-button
					(click)="eventOpened.emit(event())"
					[matTooltip]="T.SHARED_EVENT_CALENDER_OPEN_DASHBOARD | translate"
					matTooltipClass="accent"
				>
					<mat-icon fontIcon="fa-calendar-week" fontSet="fas" color="accent" />
				</button>
			}
			<sim-action-menu
				hasDataPermission="Delete"
				[permissionObj]="event()"
				appStopPropagation
				[actions]="menuActions"
				(onDelete)="deleteEvent()"
				[isDeletable]="event().state !== EventState.Archived"
			/>
			<div class="optionalAction" [class.visible]="enableSelection">
				<mat-checkbox appStopPropagation color="accent" [checked]="event().isSelected" (change)="eventSelected.emit(event())" />
			</div>
		</div>
	</section>

	<!--BODY-->
	<section class="body" [class.open]="event().open">
		<mat-divider />

		<!--DATE SELECTOR-->
		@defer (on viewport; prefetch on immediate) {
			<sim-event-day-selector [eventDays]="event().days" (onSelect)="currentDay.set($event)" />

			@if (!totalSessionCount()) {
				<div class="emptyState">
					{{ T.SHARED_EVENT_CONTAINER_NO_SESSION_FOUND | translate }}
					<mat-icon fontIcon="fa-cubes" fontSet="fas" />
				</div>
			} @else {
				<!--SESSIONS TABULATED BY DATE-->
				<div class="sessionContainer">
					@for (session of currentDay()?.sessions; track session.id) {
						<sim-session-card
							(finishedRunClickedEmitter)="selectRecording.emit($event)"
							[event]="event()"
							[finishedRunsClickable]="recordingSelectable"
							[hideDraftSessions]="hideDraftSession"
							[sessionStartable]="event().state === EventState.Active"
							[session]="session"
							[showEditAction]="false"
							[showJoinStartActions]="showJoinStartActions"
							[showOnlyRecordedScenarios]="showOnlyRecordedScenarios"
							[showRecordingExports]="showExports"
							[showRemoveAction]="false"
							[usedWithinEventSelection]="true"
							[isArchive]="isArchive"
							[isExamSchedule]="isExamSchedule"
							[creationMode]="creationMode"
						/>
					}
				</div>
			}
		} @placeholder (minimum 500ms) {
			<div class="spinnerWrapper">
				<mat-spinner diameter="50" color="accent" strokeWidth="6" />
			</div>
		}
	</section>
</div>
